/**
 * CourseyVoyage 日本語文字列テーブル
 */
import type { Strings } from './types';

export const ja: Strings = {
    'app.loading': '読み込み中...',
    'app.or': 'または',
    'app.appName': 'CourseyVoyage',
    'app.backPressToExit': 'もう一度戻ると終了します',

    'nav.dashboard': 'ダッシュボード',
    'nav.schedule': 'スケジュール',
    'nav.courses': 'コース管理',
    'nav.skills': '学習歴',
    'nav.finance': '支払い',
    'nav.settings': '設定',

    'login.welcome': 'おかえりなさい',
    'login.loggingIn': 'ログイン中...',
    'login.guest': 'ゲストログイン',
    'login.guestConfirmTitle': 'ゲストログイン確認',
    'login.guestConfirmImportant': '重要：',
    'login.guestConfirmNote': 'ゲストモードのデータはログアウト時に削除されます。データを保持するには正式アカウントにアップグレードしてください。',
    'login.guestConfirmQuestion': 'ゲストログインを続行しますか？',
    'login.cancel': 'キャンセル',
    'login.confirmLogin': '確認',
    'login.readyToStart': '学習を始める準備はできましたか？',
    'login.joinUs': '参加して、お子様のコース管理をサポートし、お子様の未来の準備をしましょう。',
    'login.googleLogin': 'Googleでログイン',
    'login.failed': 'ログインに失敗しました',
    'login.webviewWarningTitle': 'アプリ内ブラウザをご利用中です',
    'login.webviewWarningDesc': 'Googleログインはアプリ内ブラウザでは正常に動作しません。システムブラウザ（Chrome、Safariなど）で本サイトを開いてください。',
    'login.webviewGoogleDisabled': 'アプリ内ブラウザではGoogleログインをご利用いただけません。システムブラウザで本サイトを開いてください。',

    'bubble.welcome': 'CourseyVoyageへようこそ！',
    'bubble.rememberCourse': '今日のレッスンを忘れずに！',
    'bubble.wellDone': 'よくできました！この調子で！',
    'bubble.howIsLearning': '今日の学習はどうでしたか？',
    'bubble.needHelp': 'お困りですか？',
    'bubble.doubleTapToSwitch': 'ダブルタップで子供を切り替え',
    'bubble.parentTip1': 'アバターをタップでヒント',
    'bubble.parentTip2': '設定で子供を管理',
    'bubble.parentTip3': 'ダッシュボードで概要を確認',
    'bubble.parentTip4': '設定で子供やコースを追加',
    'bubble.parentTip5': 'コース管理でコースを追加',

    'welcome.noChildMessage': 'お子様が登録されていません。コース管理を開始するには、お子様を追加してください。',

    'child.all': 'すべて',
    'child.yearsOld': '歳',
    'child.edit': '編集',
    'child.delete': '削除',
    'child.addChild': '+ 子供を追加',

    'settings.title': '設定',
    'settings.childManagement': '子供管理',
    'settings.childManagementDesc': 'アバターまたは名前をタップして、表示する子供を切り替えます',
    'settings.notifications': '通知',
    'settings.notifLessonLow': 'レッスン期限間近',
    'settings.notifLessonLowDesc': '残りレッスンが閾値以下になったら通知',
    'settings.notifPaymentDue': '支払い期限リマインダー',
    'settings.notifPaymentDueDesc': '期限の7日前と3日前に通知',
    'settings.notifDailyReminder': '本日のコースリマインダー',
    'settings.notifDailyReminderDesc': '毎日授業の1時間前にリマインド',
    'settings.thresholdTitle': 'レッスンアラート閾値',
    'settings.thresholdDesc': '残りレッスンがこの値より少なくなったらアラートを表示',
    'settings.thresholdDefault': 'デフォルト閾値',
    'settings.thresholdUnit': 'レッスン',
    'settings.expiryAlertDays': '期限の何日前にアラート',
    'settings.expiryAlertDaysUnit': '日',
    'settings.account': 'アカウント',
    'settings.logout': 'ログアウト',
    'settings.logoutDesc': 'ログアウトしてログインページに戻ります',
    'settings.upgradeTitle': '正式アカウントにアップグレード',
    'settings.upgradeDesc': 'アップグレードすると、データのバックアップやデバイス間の同期が可能になります。すべてのデータが保持されます。',
    'settings.upgradeWithGoogle': 'Googleでアップグレード',
    'settings.upgrading': 'アップグレード中...',
    'settings.upgradeSuccess': 'アップグレードが完了しました！Googleアカウントでログインできます。',
    'settings.anonymousLogoutTitle': 'ログアウトの確認',
    'settings.anonymousLogoutImportant': '重要：',
    'settings.anonymousLogoutWarning': '現在ゲストモードです。ログアウトするとすべてのデータが削除されます。',
    'settings.anonymousLogoutConfirm': 'ログアウトしてもよろしいですか？',
    'settings.confirmLogout': 'ログアウトする',
    'settings.aboutTitle': 'CourseyVoyageについて',
    'settings.aboutVersion': 'バージョン {version}',
    'settings.aboutDesc': '保護者が子供の課外コース、レッスン数、支払い状況を管理するためのツールです。',
    'settings.language': '言語',
    'settings.languageDesc': 'インターフェースの言語を選択',
    'settings.exportTitle': 'データエクスポート',
    'settings.exportDesc': '選択した期間内のすべてのコースデータを Excel ファイルでエクスポートします。',
    'settings.exportDateRange': '期間',
    'settings.exportButton': 'エクスポート',
    'settings.exporting': 'エクスポート中...',
    'settings.exportSuccess': 'エクスポート完了',
    'settings.exportEmpty': 'この期間にコースデータがありません',
    'settings.exportError': 'エクスポートに失敗しました。しばらくしてから再試行してください',
    'export.reportTitle': 'コースデータエクスポート',
    'export.dateRangeLabel': '期間',
    'export.generated': '出力日時',
    'export.noData': 'この期間にコースデータがありません。',
    'export.date': '日付',
    'export.amount': '金額',
    'export.note': '備考',
    'export.recordType': '種類',
    'export.sheetCourses': 'コース',
    'export.sheetPayments': '支払い記録',
    'export.sheetRecords': '出席記録',
    'export.colChild': '子供',
    'export.colCourseName': 'コース名',
    'export.colInstitution': '機関',
    'export.colTeacher': '講師',
    'export.colStartDate': '開始日',
    'export.colEndDate': '終了日',
    'export.colTotalLessons': '総レッスン数',
    'export.colUsedLessons': '消化数',
    'export.colStatus': '状態',
    'export.colCourseFee': 'コース料金',
    'export.sectionPayments': '期間内支払い',
    'export.sectionRecords': '期間内出席記録',
    'export.colRemainingLessons': '残り',
    'export.colTotalPaid': '支払済合計',
    'export.colTotalRefunded': '返金合計',
    'export.colNetPaid': '手取額',
    'export.colRemainingPayment': '未払い',
    'export.paymentStatusPaid': '支払済',
    'export.paymentStatusUnpaid': '未払い',
    'export.colEffectiveEndDate': '有効終了日',
    'export.sectionAllPayments': '支払い記録',
    'export.sectionAllRefunds': '返金記録',
    'export.scheduleWeekPrefix': '曜',
    'export.recordCompleted': '受講完了',
    'export.recordLeave': '欠席',
    'export.recordCancelled': '休講',
    'export.recordMakeup': '振替',
    'export.colSchedule': '曜日',
    'export.colMonth': '月',

    'modal.addChild': '子供を追加',
    'modal.editChild': '子供を編集',
    'modal.deleteChild': '子供を削除',
    'modal.childName': '名前',
    'modal.childNamePlaceholder': '子供の名前を入力',
    'modal.gender': '性別',
    'modal.genderMale': '男性',
    'modal.genderFemale': '女性',
    'modal.birthdate': '生年月日',
    'modal.avatar': 'アバター',
    'modal.cancel': 'キャンセル',
    'modal.skip': '後で',
    'modal.save': '保存',
    'modal.saving': '保存中...',
    'modal.add': '追加',
    'modal.delete': '削除',
    'modal.deleting': '削除中...',
    'modal.confirmDeleteChild': '「{name}」を削除しますか？元に戻せません。',
    'modal.confirmDeleteChildNote': '元に戻せません',
    'modal.duplicateChildName': '同じ名前の子供が既にいます',
    'modal.addFailed': '追加に失敗しました。もう一度お試しください。',
    'modal.updateFailed': '更新に失敗しました。もう一度お試しください。',
    'modal.deleteFailed': '削除に失敗しました。もう一度お試しください。',

    'dashboard.title': 'ダッシュボード',
    'dashboard.activeCourses': '進行中コース',
    'dashboard.todayCourses': '本日のコース',
    'dashboard.pendingPayments': '未払',
    'dashboard.lessonLowAlert': 'レッスン期限間近',
    'dashboard.pendingPaymentsAlert': '未払 {count} 件',
    'dashboard.checkFinance': '支払いページで確認',
    'dashboard.noCoursesToday': '本日のコースはありません。お休みください！',
    'dashboard.courseList': 'コース一覧',
    'dashboard.checkIn': 'チェックイン',
    'dashboard.checkInSuccess': '✅ チェックイン記録しました！',
    'dashboard.remaining': '残り',
    'dashboard.remainingToPay': '残り支払額',
    'dashboard.lessons': 'レッスン',
    'dashboard.payButton': '支払う',

    'courses.title': 'コース管理',
    'courses.filterAll': 'すべて',
    'courses.filterActive': '進行中',
    'courses.filterLow': '期限間近',
    'courses.filterExpired': '未払',
    'courses.filterPaid': '支払済',
    'courses.filterDone': '完了',
    'courses.filterPaused': '一時停止',
    'courses.sortBy': '並び替え',
    'courses.sortByCreatedAt': '作成日時',
    'courses.sortByStartDate': '開始日',
    'courses.sortByEndDate': '終了日',
    'courses.sortByName': 'コース名',
    'courses.sortByTotalLessons': '総レッスン数',
    'courses.sortByRemainingLessons': '残りレッスン数',
    'courses.sortByFee': '料金',
    'courses.sortOrderAsc': '昇順（クリックで降順に切替）',
    'courses.sortOrderDesc': '降順（クリックで昇順に切替）',
    'courses.loading': '読み込み中...',
    'courses.empty': '該当するコースがありません',
    'courses.emptyHint': '+ をタップしてコースを追加',
    'courses.pageInfo': '{current} / {total} ページ',
    'courses.addCourse': 'コースを追加',
    'courses.addChildFirst': '先に子供を追加してください',
    'courses.addFailed': '追加に失敗しました。もう一度お試しください。',
    'courses.dateRange': '{start} ～ {end}',
    'courses.dateRangeStartOnly': '{start} ～',
    'courses.totalPaid': '支払い合計',
    'courses.totalRefunded': '返金合計',
    'courses.netPaid': '実質支払額',
    'courses.pleaseFillCourseName': 'コース名を入力してください',
    'courses.pleaseFillStartDate': '開始日を選択してください',
    'courses.courseFeeInvalid': 'コース料金は負の数にできません',
    'courses.pleaseFillCourseFee': 'コース料金を入力してください',
    'courses.courseName': 'コース名 *',
    'courses.courseNamePlaceholder': '例：英会話',
    'courses.courseType': 'コースタイプ',
    'courses.institution': '機関',
    'courses.institutionPlaceholder': '例：ABCスクール',
    'courses.teacher': '講師',
    'courses.teacherPlaceholder': '例：田中先生',
    'courses.optionalSuffix': '（任意）',
    'courses.weekdays': '曜日',
    'courses.startTime': '開始時間',
    'courses.endTime': '終了時間',
    'courses.location': '場所',
    'courses.locationPlaceholder': '例：〇〇市〇〇区〇〇町1-2-3（または教室名）',
    'courses.startDate': '開始日',
    'courses.endDate': '終了日',
    'courses.byLessons': '総レッスン数で',
    'courses.byEndDate': '終了日で',
    'courses.courseFee': 'コース料金',
    'courses.courseFeePlaceholder': '例：9000（円）',
    'courses.paymentMode': '支払い方法',
    'courses.paymentFull': '一括払い',
    'courses.paymentMonthly': '月払い',
    'courses.paymentPerClass': '授業払い',
    'courses.monthlyFee': '月額',
    'courses.perClassFee': '1授業あたり金額',
    'courses.perClassFeePlaceholder': '例：500',
    'courses.monthlyFeePlaceholder': '例：3000',
    'courses.dueDayOfMonth': '毎月の支払い期限日',
    'courses.dueByDay': '{day} 日まで',
    'courses.dueDayOfMonthPlaceholder': '例：5（毎月5日まで）',
    'courses.reminderDaysBefore': '期限の何日前にリマインド',
    'courses.reminderDaysBeforePlaceholder': '例：3',
    'courses.pleaseFillDueDayOfMonth': '毎月の支払期日を入力してください',
    'courses.pleaseFillReminderDaysBefore': '期限前何日からリマインドするかを入力してください',
    'courses.totalLessons': '総レッスン数',
    'courses.pleaseFillTotalLessons': '総レッスン数を入力してください',
    'courses.pleaseFillEndDate': '終了日を選択してください',
    'courses.pleaseSelectWeekdays': '終了日を使用する場合は先に曜日を選択してください',
    'courses.selectWeekday': '曜日を選択',
    'courses.addSlot': '授業を追加',
    'courses.scheduleOverlap': '同日の授業時間が重複することはできません',
    'courses.noLessonsInRange': '選択した曜日の日付範囲内にレッスンがありません',
    'courses.totalLessonsLessThanUsed': '計算された総レッスン数（{computed}）は既に受講済みのレッスン数（{used}）より少なくできません。日付または曜日を調整してください。',
    'courses.endTimeMustAfterStart': '終了時間は開始時間より後にしてください',
    'courses.alertThreshold': '残りがこれ以下でアラート',
    'courses.courseColor': '色',
    'courses.status': 'ステータス',
    'courses.editCourse': 'コースを編集',
    'courses.confirmDeleteCourse': '「{name}」を削除しますか？コース全体（出席記録・支払い記録など）が完全に削除されます。元に戻せません。',
    'courses.updateFailed': '更新に失敗しました。もう一度お試しください。',
    'courses.deleteFailed': '削除に失敗しました。もう一度お試しください。',
    'courses.pauseCourse': 'コースを一時停止',
    'courses.resumeCourse': 'コースを再開',
    'courses.copyCourse': 'コピー',
    'courses.leaveDeductsLesson': '欠席時にレッスンを消化する',

    'courseType.語言': '言語',
    'courseType.音樂': '音楽',
    'courseType.體育': 'スポーツ',
    'courseType.學科': '学習',
    'courseType.才藝': '芸能',
    'courseType.美術': '美術',
    'courseType.其他': 'その他',

    'status.active': '進行中',
    'status.low': '期限間近',
    'status.expired': '未払',
    'status.paymentPaid': '支払済',
    'status.paused': '一時停止',
    'status.done': '完了',

    'detail.back': '戻る',
    'detail.edit': '編集',
    'detail.delete': '削除',
    'detail.remainingLessons': '残り',
    'detail.usedLessons': '受講済',
    'detail.totalLessons': '合計',
    'detail.usedPercent': '{pct}% 受講済',
    'detail.completed': '✅ 受講完了',
    'detail.leave': '🤒 欠席',
    'detail.makeup': '🔁 振替',
    'detail.cancelled': '🎒 休講',
    'detail.courseInfo': '📋 コース情報',
    'detail.institution': '機関',
    'detail.teacher': '講師',
    'detail.weekdays': '曜日',
    'detail.timeRange': '時間',
    'detail.startDate': '開始日',
    'detail.endDate': '終了日',
    'detail.location': '場所',
    'detail.leaveDeductsLesson': '欠席で消化',
    'detail.leaveDeductsLessonYes': 'する',
    'detail.leaveDeductsLessonNo': 'しない',
    'detail.courseFee': 'コース料金',
    'detail.contact': '連絡先',
    'detail.belongsTo': '子供',
    'detail.records': '📅 記録',
    'detail.noRecords': '記録はまだありません',
    'detail.unrecordedLessons': '未記録',
    'detail.noUnrecordedLessons': '未記録はありません',
    'detail.futureLessons': '今後の授業',
    'detail.noFutureLessons': '今後の授業はありません',
    'detail.editFutureLesson': '日時を編集',
    'detail.futureEditOriginal': '元の枠',
    'detail.futureEditDate': '日付',
    'detail.futureEditTime': '時間',
    'detail.futureEditDateMustBeFuture': '本日以降の日付を選択してください',
    'detail.futureEditDateExceedsCourseEnd': '日付はコース終了日（{end}）を超えられません',
    'detail.futureEditTargetHasRecord': 'この日時には既に記録があります。別の枠を選んでください。',
    'detail.confirmEditFutureLesson': '{fromDate} {fromStart}～{fromEnd} を {toDate} {toStart}～{toEnd} に変更しますか？',
    'detail.futureEditFailed': '今後の授業の更新に失敗しました',
    'detail.prevPage': '前へ',
    'detail.nextPage': '次へ',
    'detail.paymentRecords': '💰 支払い記録',
    'detail.noPaymentRecords': '支払い記録はありません',
    'detail.addPayment': '+ 支払いを追加',
    'detail.loading': '読み込み中...',
    'detail.notFound': 'コースが見つかりません',
    'detail.backToCourses': 'コース一覧に戻る',
    'detail.recordFailed': '記録に失敗しました。もう一度お試しください。',
    'detail.makeupDate': '振替日',
    'detail.makeupTime': '時間',
    'detail.makeupNote': '備考（任意）',
    'detail.addMakeup': '振替を追加',
    'detail.makeupExceedsTotal': 'このコースは回数制です。残り回数がありません。振替を追加できません。',
    'detail.makeupDateNotFuture': '振替日は未来の日付にできません。今日以前の日付を選択してください。',
    'detail.addInsertedLesson': '➕ 授業を追加',
    'detail.insertedLessonDate': '授業日',
    'detail.insertedLessonTag': '追加振替',
    'detail.editInsertedLesson': '追加授業の備考を編集',
    'detail.removeInsertedLesson': '追加を取消',
    'detail.confirmRemoveInserted': 'この追加授業を取消しますか？',
    'detail.insertedExceedsTotal': '残り回数が不足しているため、授業を追加できません。',
    'detail.insertedDateMustBeFuture': '明日以降の日付を選択してください。',
    'detail.insertedDateBeforeStart': 'コース開始日より前の日付は選べません。',
    'detail.insertedDateAfterEnd': 'コース終了日を超える日付は選べません。',
    'detail.insertedPausedNotAllowed': 'コース休止中は、休止日（含）以降に授業を追加できません。',
    'detail.insertedSlotConflict': 'この日時は既に使用されています。',
    'detail.insertedTimeOverlap': 'この時間帯は同日の他の授業と重なります。',
    'detail.insertedEndTimeBeforeStart': '終了時刻は開始時刻より後にしてください。',
    'detail.editRecord': '編集',
    'detail.deleteRecord': '削除',
    'detail.confirmDeleteRecord': 'この記録を削除しますか？',
    'detail.note': '備考',
    'detail.refundRecords': '返金記録',
    'detail.refundDate': '返金日',
    'detail.addRefund': '＋ 返金を追加',
    'detail.editPayment': '支払いを編集',
    'detail.confirmDeletePayment': 'この支払い記録を削除しますか？',
    'detail.noRefundRecords': '返金記録はありません',
    'detail.noRefundableAmount': '返金可能金額がありません',
    'detail.refundExceedsPayments': '返金額は支払い総額を超えられません。最大 NT$ {max}',
    'detail.refundMaxHint': '最大返金可能：NT$ {max}',

    'payment.add': '支払いを追加',
    'payment.date': '支払い日',
    'payment.amount': '金額 (円) *',
    'payment.month': '支払い月',
    'payment.monthPlaceholder': '例：2025-03',
    'payment.amountPlaceholder': '例：9000',
    'payment.lessons': '購入レッスン数',
    'payment.lessonsPlaceholder': '例：30',
    'payment.method': '支払い方法',
    'payment.status': '支払い状況',
    'payment.dueDate': '期限',
    'payment.note': '備考（任意）',
    'payment.notePlaceholder': '例：第1期分',
    'payment.perClassAmountHint': '授業払いコースは授業数で金額を試算します。実際の支払いに合わせて入力してください。',
    'payment.receipt': '領収書（支払い証明）',
    'payment.receiptSelected': '選択済み：{name}',
    'payment.receiptRemove': '削除',
    'payment.receiptRemoveExisting': '領収書を削除',
    'payment.receiptView': '領収書を表示',
    'payment.receiptNone': '領収書がアップロードされていません',
    'payment.receiptUploadFailed': '領収書のアップロードに失敗しました。もう一度お試しください。',
    'payment.receiptAlt': '領収書（支払い証明）',
    'payment.receiptAltCurrent': '現在の領収書',

    'paymentMethod.現金': '現金',
    'paymentMethod.匯款': '振込',
    'paymentMethod.信用卡': 'クレジットカード',
    'paymentMethod.LINE Pay': 'LINE Pay',

    'paymentStatus.paid': '支払済',
    'paymentStatus.pending': '未払い',
    'paymentStatus.overdue': '期限超過',

    'finance.title': '支払い',
    'finance.paid': '✅ 支払済',
    'finance.pending': '⏳ 未払い',
    'finance.totalRemainingEstimate': '未払い総額（見積）',
    'finance.overdue': '🔴 期限超過',
    'finance.categoryChart': 'カテゴリ別支出',
    'finance.monthlyChart': '過去6ヶ月',
    'finance.noItems': '{status}の項目がありません',
    'finance.markPaid': '支払済にする',
    'finance.markPaidSuccess': '✅ 支払済にしました！',
    'finance.dueDate': '期限：',
    'finance.paymentRefundRecords': '支払い・返金記録',

    'schedule.title': 'スケジュール',
    'schedule.dayView': '日',
    'schedule.weekView': '週',
    'schedule.monthView': '月',
    'schedule.week': '週',
    'schedule.monthYear': '{year}年{month}月',
    'schedule.monthPart': '{month}月',
    'schedule.prevDay': '前日',
    'schedule.nextDay': '翌日',
    'schedule.prevWeek': '前の週',
    'schedule.nextWeek': '次の週',
    'schedule.goToToday': '今日',
    'schedule.prevMonth': '前の月',
    'schedule.nextMonth': '次の月',
    'schedule.actionCheckIn': '出勤',
    'schedule.actionLeave': '欠席',
    'schedule.actionAbsence': '休講',
    'schedule.confirmRecord': '「{action}」にしますか？',

    'weekday.sun': '日',
    'weekday.mon': '月',
    'weekday.tue': '火',
    'weekday.wed': '水',
    'weekday.thu': '木',
    'weekday.fri': '金',
    'weekday.sat': '土',

    'skills.title': '学習歴',
    'skills.intro': 'お子様のコースとスキルを記録します。詳細な分析は近日公開予定です。',
    'skills.activeByType': '進行中コース',
    'skills.overview': 'スキル概要',
    'skills.timelineToday': '本日の時間割',
    'skills.timelineByDate': 'コース日付タイムライン',
    'skills.timelineEmpty': 'コース日付がありません',
    'skills.preview': 'プレビュー',
    'skills.lessonsAttended': '約{hours}レッスン受講',
    'skills.comingSoon': '詳細なスキル分析機能は開発中です。お楽しみに！',
    'skills.empty': 'コース記録はまだありません',
    'skills.emptyHint': 'コースを追加すると学習歴が蓄積されます',
    'skills.goToAddCourse': 'コースを追加',
    'skills.timelineRangeLabel': '表示期間',
    'skills.timelineFrom': '開始',
    'skills.timelineTo': '終了',
    'skills.timelineReset': 'すべて',
    'skills.typeLang': '言語',
    'skills.typeMusic': '音楽',
    'skills.typeSports': 'スポーツ',
    'skills.typeAcademic': '学習',
    'skills.typeTalent': '芸能',
    'skills.typeFineArts': '美術',
    'skills.typeOther': 'その他',

    'offline.modal.title': 'オフライン',
    'offline.modal.description': 'キャッシュデータを表示しています。アプリは引き続きご利用いただけます。接続が回復すると変更が同期されます。',
    'offline.modal.confirm': 'OK',
    'offline.recovered.title': '接続が回復しました',
    'offline.recovered.description': 'ネットワークが復旧しました。最新データを取得するには再読み込みしてください。',
    'offline.recovered.reload': '今すぐ再読み込み',
    'offline.recovered.later': '後で',
    'offline.noData.title': '読み込めません',
    'offline.noData.description': 'オフラインでキャッシュデータがありません。インターネットに接続して更新してください。',
    'offline.noData.reload': '更新',

    'install.title': '{name} をデバイスにインストール',
    'install.titleInstalled': '{name} をインストール済み',
    'install.howToInstall': '{name} のインストール方法',
    'install.benefits': 'インストール後のメリット：',
    'install.benefit1': '高速読み込み',
    'install.benefit2': 'ネイティブアプリ体験、全画面表示',
    'install.benefit3': '即時通知',
    'install.benefit4': 'オフライン利用',
    'install.installing': 'インストール中...',
    'install.installNow': '今すぐインストール',
    'install.viewInstructions': 'インストール方法を表示',
    'install.oneClickNote': '上のボタンをタップしてインストール',
    'install.manualNote': 'インストール手順をご案内します',
    'install.dontShowAgain': '表示しない',
    'install.later': '後で',
    'install.useDesktopApp': 'デスクトップアプリをご利用ください',
    'install.useDesktopNote': 'CourseyVoyage はインストール済みです！',
    'install.continueBrowser': 'ブラウザで続ける',
    'install.desktopHint': 'ベストな体験のため、インストール済みのデスクトップアプリをご利用ください：',
    'install.back': '戻る',
    'install.youAreUsing': '使用中：',

    'auth.notLoggedIn': 'ユーザーがログインしていません',
};
